/* ==========================================================================
   DARK MODE switch (10/18/26). Light is the default. A visitor who flips the
   GO DARK toggle keeps dark mode on every page and on later visits
   (localStorage 'dm-mode'). Also runs the phone buy bar.
   ========================================================================== */
(function () {
  var KEY = 'dm-mode';
  var root = document.documentElement;

  function save(mode) { try { localStorage.setItem(KEY, mode); } catch (e) {} }
  function isDark() { return root.classList.contains('dm-dark'); }

  function sync() {
    var dark = isDark();
    var buttons = document.querySelectorAll('[data-dm-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', dark ? 'true' : 'false');
    }
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      if (!meta.getAttribute('data-dm-light')) meta.setAttribute('data-dm-light', meta.getAttribute('content') || '');
      meta.setAttribute('content', dark ? '#1A1A1A' : meta.getAttribute('data-dm-light'));
    }
  }

  function apply(dark) {
    root.classList.toggle('dm-dark', dark);
    save(dark ? 'dark' : 'light');
    sync();
  }

  function flip(event) {
    var next = !isDark();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (document.startViewTransition && !reduce) {
      var x = event && event.clientX ? event.clientX : window.innerWidth - 60;
      var y = event && event.clientY ? event.clientY : 40;
      var r = Math.hypot(Math.max(x, window.innerWidth - x), Math.max(y, window.innerHeight - y));
      root.classList.add('dm-vt');
      var t = document.startViewTransition(function () { apply(next); });
      t.ready.then(function () {
        root.animate(
          { clipPath: ['circle(0px at ' + x + 'px ' + y + 'px)', 'circle(' + r + 'px at ' + x + 'px ' + y + 'px)'] },
          { duration: 700, easing: 'cubic-bezier(.4, 0, .2, 1)', pseudoElement: '::view-transition-new(root)' }
        );
      }).catch(function () {});
      t.finished.then(function () { root.classList.remove('dm-vt'); }, function () { root.classList.remove('dm-vt'); });
    } else {
      if (!reduce) {
        root.classList.add('dm-anim');
        setTimeout(function () { root.classList.remove('dm-anim'); }, 650);
      }
      apply(next);
    }

    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('dm_mode_toggle', { mode: next ? 'dark' : 'light' });
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-dm-toggle]') : null;
    if (!button) return;
    event.preventDefault();
    flip(event);
  });

  /* Another tab flipped the switch: follow it */
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    root.classList.toggle('dm-dark', event.newValue === 'dark');
    sync();
  });

  /* Phone buy bar: in after the first screen, out at the footer */
  function buybar() {
    var bar = document.querySelector('[data-dm-buybar]');
    if (!bar) return;
    var footer = document.querySelector('.shopify-section--footer') || document.querySelector('footer');
    var atFooter = false;
    var update = function () {
      bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.6 && !atFooter);
    };
    if (footer && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        atFooter = entries[0].isIntersecting;
        update();
      }, { rootMargin: '0px 0px 120px 0px' }).observe(footer);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init() { sync(); buybar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ==========================================================================
   DARK MODE in its own type (10/19/26). Every "DARK MODE" in page text is set in
   Saira ExtraBold, the weight reserved for the name. Headings already use it; this
   catches body copy, buttons, FAQs, product text, reviews and anything loaded later.
   ========================================================================== */
(function () {
  var WORD = 'DARK MODE';
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, TITLE: 1, CODE: 1, PRE: 1 };

  function skip(el) {
    if (!el || SKIP_TAGS[el.tagName]) return true;
    if (el.closest('.dm-wm, svg, [contenteditable=""], [contenteditable="true"], split-lines')) return true;
    return false;
  }

  function wrap(root) {
    if (!root) return;
    if (root.nodeType === 3) { root = root.parentNode; }
    if (!root || root.nodeType !== 1 || skip(root) && root !== document.body) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.nodeValue && node.nodeValue.indexOf(WORD) !== -1 && !skip(node.parentElement)
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var found = [];
    while (walker.nextNode()) found.push(walker.currentNode);
    for (var i = 0; i < found.length; i++) {
      var node = found[i];
      var parts = node.nodeValue.split(WORD);
      var frag = document.createDocumentFragment();
      for (var j = 0; j < parts.length; j++) {
        if (parts[j]) frag.appendChild(document.createTextNode(parts[j]));
        if (j < parts.length - 1) {
          var span = document.createElement('span');
          span.className = 'dm-wm';
          span.textContent = WORD;
          frag.appendChild(span);
        }
      }
      if (node.parentNode) node.parentNode.replaceChild(frag, node);
    }
    // 10/26: the ™ now comes from CSS, so drop a typed ™ right after the name (e.g. "<strong>DARK MODE</strong>™").
    var spans = root.querySelectorAll ? root.querySelectorAll('.dm-wm') : [];
    for (var s = 0; s < spans.length; s++) {
      var el = spans[s], next = el.nextSibling;
      while (!next && el.parentNode && el.parentNode !== root && el.parentNode.lastChild === el) { el = el.parentNode; next = el.nextSibling; }
      if (next && next.nodeType === 3 && /^[\u2122\u00AE]/.test(next.nodeValue)) next.nodeValue = next.nodeValue.replace(/^[\u2122\u00AE]/, '');
    }
  }

  function start() {
    wrap(document.body);
    if (!('MutationObserver' in window)) return;
    var queue = [];
    var pending = false;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) queue.push(added[j]);
        if (records[i].type === 'characterData') queue.push(records[i].target);
      }
      if (pending || !queue.length) return;
      pending = true;
      requestAnimationFrame(function () {
        var nodes = queue; queue = []; pending = false;
        for (var k = 0; k < nodes.length; k++) {
          if (nodes[k].isConnected) wrap(nodes[k].nodeType === 1 ? nodes[k] : nodes[k].parentNode);
        }
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ==========================================================================
   Link fixes (10/23/26)
   1. Any link to the all-products page goes to the 5-Pack (one hero product).
   2. The comparison table's $0 helper products stay visible but stop being links.
   3. Launch night: Instagram and TikTok point to @goodhourmatcha until 12:00 PM ET
      on 10/29, after @darkmodematcha moves to our accounts (the Instagram hold ends
      around 11:23 AM). From then on the theme's own links (@darkmodematcha) apply.
   ========================================================================== */
(function () {
  var PDP = '/products/dark-mode-matcha-001-5-pack';
  var HELPERS = ['/products/cafe-latte', '/products/home-ceremony', '/products/dh-pouch-imactive'];
  var HANDLE_SWITCH = Date.UTC(2026, 9, 29, 16, 0, 0);

  function pathOf(href) {
    return href.replace(/^https?:\/\/[^\/]+/i, '').split('#')[0].split('?')[0].replace(/\/$/, '') || '/';
  }

  function fixLinks() {
    var early = Date.now() < HANDLE_SWITCH;
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      var path = pathOf(href);
      if (path === '/collections/all') { a.setAttribute('href', PDP); continue; }
      if (HELPERS.indexOf(path) !== -1) { a.removeAttribute('href'); continue; }
      if (early) {
        if (/instagram\.com\/darkmodematcha\/?$/i.test(href)) a.setAttribute('href', 'https://www.instagram.com/goodhourmatcha');
        else if (/tiktok\.com\/@darkmodematcha\/?$/i.test(href)) a.setAttribute('href', 'https://www.tiktok.com/@goodhourmatcha');
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixLinks);
  else fixLinks();
  document.addEventListener('shopify:section:load', fixLinks);
})();

/* ==========================================================================
   10/23/26: the sign-up popup never sits on top of the cart. On /cart, and while
   the "Added to your cart" box or the cart drawer is open, a Klaviyo popup is
   closed (it then follows its own "show again" timing) and hidden while it closes.
   ========================================================================== */
(function () {
  var root = document.documentElement;
  function onCartPage() { return /\/cart\/?$/.test(location.pathname); }
  function cartOpen() {
    return onCartPage() || !!document.querySelector('cart-notification-drawer[open], cart-drawer[open], #cart-drawer[open]');
  }
  function closePopup() {
    var forms = document.querySelectorAll('[aria-label="POPUP Form"]');
    if (!forms.length) return;
    /* The cart box treats any click outside it as "close". Pause its focus trap while the popup's
       close button is clicked, so the cart box stays open, then resume it. */
    var paused = [];
    var drawers = document.querySelectorAll('cart-notification-drawer[open], cart-drawer[open]');
    for (var d = 0; d < drawers.length; d++) {
      try {
        var trap = drawers[d].focusTrap;
        if (trap && typeof trap.pause === 'function' && trap.active !== false && !trap.paused) { trap.pause(); paused.push(trap); }
      } catch (e) {}
    }
    for (var i = 0; i < forms.length; i++) {
      var btn = forms[i].querySelector('button.klaviyo-close-form, button[aria-label="Close dialog"]');
      if (btn && !(forms[i].__dmClosing > Date.now() - 600)) { forms[i].__dmClosing = Date.now(); btn.click(); }
    }
    setTimeout(function () {
      for (var k = 0; k < paused.length; k++) { try { paused[k].unpause(); } catch (e) {} }
    }, 0);
  }
  function update() {
    var open = cartOpen();
    root.classList.toggle('dm-cart-open', open);
    if (open) closePopup();
  }
  window.addEventListener('klaviyoForms', function (event) {
    if (event && event.detail && event.detail.type === 'open' && cartOpen()) {
      root.classList.add('dm-cart-open');
      /* The popup can take a moment to finish drawing, so try a few times. If it still hasn't closed after
         two seconds, show it rather than leave an invisible dialog holding the keyboard focus. */
      [60, 300, 700, 1200].forEach(function (ms) {
        setTimeout(function () { if (cartOpen()) closePopup(); }, ms);
      });
      setTimeout(function () {
        if (document.querySelector('[aria-label="POPUP Form"]')) root.classList.remove('dm-cart-open');
      }, 2000);
    }
  });
  function start() {
    update();
    new MutationObserver(update).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
